<script>
	module.exports = {
		props: {
			icon: {
				required: true,
				type: String,
				default: 'star-icon'
			},
			color: {
				required: true,
				type: String,
				default: 'highlighter-purple'
			}
		},
		components: {
			'bookmark-add-icon': require('components/svg/bookmark-add-icon.vue').default,
			'bok-bookmark-icon': require('components/svg/bok-bookmark-icon.vue').default,
			'magnifying-glass-icon': require('components/svg/magnifying-glass-icon.vue').default,
			'print-icon': require('components/svg/print-icon.vue').default,
			'star-icon': require('components/svg/star-icon.vue').default
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.journey-icon-container {
		width: 3rem;
		height: 3rem;
		margin-right: 1rem;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: $c-highlighter-purple;

		&.dark-blue {
			background-color: $c-blue-dark;
		}

		&.highlighter-green {
			background-color: $c-highlighter-green;
		}

		svg {
			height: 50%;
			width: auto;
			fill: $c-white;
			stroke: none;

			&.bok-bookmark-icon {
				stroke: $c-white;
			}
		}
	}
</style>
<template>
	<div
		class="journey-icon-container"
		:class="color">
		<component :is="icon"></component>
	</div>
</template>
